<template>
  <div>
     <b-navbar toggleable="lg" class="header"  fixed="top" variant="faded" type="light">
        <b-navbar-brand :to="{name:'inicio'}">Dyego</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item :to="{name:'inicio'}" exact>Inicio</b-nav-item>
            <b-nav-item :to="{name:'sobre_mi'}">Sobre mi</b-nav-item>
            <b-nav-item :to="{name:'portafolio'}">Portafolio</b-nav-item>
          </b-navbar-nav> 
        </b-collapse>
    </b-navbar>
  </div>
</template>    
<script>
export default {
  name: 'navBar',
}
</script>
<style>
  .header{
    background-color:#fff;
  }
</style>
   